<div class="user-create-container">
  @if (isLoading()) {
  } @else {
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="form-grid">
        <!-- Nome -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome completo</mat-label>
          <input
            matInput
            formControlName="name"
            placeholder="Digite o nome completo"
          />
          <mat-icon matPrefix>person</mat-icon>
          @if (
            userForm.controls.name.invalid && userForm.controls.name.touched
          ) {
            <mat-error>{{ getErrorMessage("name") }}</mat-error>
          }
        </mat-form-field>

        <!-- E-mail -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            placeholder="exemplo@email.com"
          />
          <mat-icon matPrefix>email</mat-icon>
          @if (
            userForm.controls.email.invalid && userForm.controls.email.touched
          ) {
            <mat-error>{{ getErrorMessage("email") }}</mat-error>
          }
        </mat-form-field>

        <!-- Função -->
        <mat-form-field appearance="outline">
          <mat-label>Perfil</mat-label>
          <mat-select formControlName="role">
            @for (role of roleOptions; track role) {
              <mat-option [value]="role.value">
                {{ role.label }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matPrefix>badge</mat-icon>
          @if (
            userForm.controls.role.invalid && userForm.controls.role.touched
          ) {
            <mat-error>{{ getErrorMessage("role") }}</mat-error>
          }
        </mat-form-field>

        @if (shouldRequestOrganization) {
          <mat-form-field appearance="outline">
            <mat-label>Empresa</mat-label>
            <mat-select formControlName="organizationId">
              @for (company of companies; track company) {
                <mat-option [value]="company.value">
                  {{ company.label }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matPrefix>business</mat-icon>
            @if (
              userForm.controls.organizationId.invalid &&
              userForm.controls.organizationId.touched
            ) {
              <mat-error>{{ getErrorMessage("organizationId") }}</mat-error>
            }
          </mat-form-field>

          @if (companies.length === 0) {
            <div class="organization-hint warning">
              Nenhuma empresa disponível. Carregue novamente a página ou
              verifique suas permissões.
            </div>
          }
        } @else {
          <div class="organization-hint">
            {{ organizationInfoText }}
          </div>
        }
      </div>

      <!-- Ações -->
      <div class="actions">
        <button
          mat-stroked-button
          type="button"
          (click)="onCancel()"
          [disabled]="isSubmitting()"
        >
          {{ cancelButtonLabel }}
        </button>
        @if (showSubmitButton) {
          <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="disableSubmitButton"
          >
            @if (isSubmitting()) {
              <mat-spinner diameter="20"></mat-spinner>
            } @else {
              <mat-icon>save</mat-icon>
            }
            <span>{{ submitButtonLabel }}</span>
          </button>
        }
      </div>
    </form>
  }
</div>
